import React from "react";
import { Dimensions, Image, Platform } from "react-native";

import { phoneThreshold } from "../globalUtils";

const logo = require("../../assets/img/brand2.png");

const aspectRatio = 157 / 34;

const AppBrand = ({ style = {} }) => {
  const { width } = Dimensions.get("window");

  const logoWidth = width > phoneThreshold ? 189 : 138;
  const logoHeight = logoWidth / aspectRatio;

  return Platform.OS === "web" ? (
    <Image
      resizeMode={"contain"}
      source={logo}
      style={{
        width: 115,
        height: 25,
        ...style,
      }}
    />
  ) : (
    <Image
      resizeMode={"contain"}
      source={logo}
      style={{
        width: logoWidth,
        height: logoHeight,
        ...style,
      }}
    />
  );
};

export default AppBrand;
